import { createStore, createEffect, createEvent, combine } from 'effector';
import { ApiUtils } from '@shared/utils';
import { DashboardApi, RequestStrategyEnum, type WithSignal, type DashboardItemsRequest, type Merchant } from '@shared/api';

const getMerchantsEffect = createEffect(({ signal, ...request }: WithSignal<DashboardItemsRequest>) => DashboardApi.getMerchants(request, signal));
const clearEvent = createEvent();

const $dataStore = createStore<Merchant[]>([])
  .on(getMerchantsEffect.done, (_, data) => data.result.data ?? [])
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(getMerchantsEffect.pending, (_, data) => data)
  .on(getMerchantsEffect.fail, (_, data) => ApiUtils.abortApiLoadingFailCaseTrigger(data.error))
  .on(getMerchantsEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(getMerchantsEffect, () => null)
  // .on(getMerchantsEffect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(getMerchantsEffect.fail, () => 'Something went wrong while fetching Most used merchants. Please try again.')
  .on(getMerchantsEffect.done, () => null)
  .reset(clearEvent);

const getMerchantsApi = ApiUtils.wrapperApi(getMerchantsEffect, RequestStrategyEnum.Abort);
clearEvent.watch(() => getMerchantsApi.cancel());

export const $dashboardMerchantsStore = {
  events: {
    getMerchants: getMerchantsApi.trigger,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
